import React from "react";
import { Redirect } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from "react-router-dom";
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { Box, Button, Paper } from '@mui/material';

import { withStyles } from '@mui/styles';
import SignUpTemplate from "../components/templates/SignUpTemplate";
import SignUpSteps from "../components/SignUpSteps";
import MixpanelOnload from "../components/MixpanelOnload";
import MixpanelButton from "../components/MixpanelButton";

import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import GA from '../utils/GoogleAnalytics';
const moment = require('moment');

const useStyles = theme => ({
    '@global': {
    },
    paper: {
        padding: '8px',
    },
    'catchIcon': {
        fontSize: '3rem !important',
        marginRight: '10px',
        lineHeight: '6rem'
    },
    'calculatedPrice': {
        fontSize: '2rem',
        fontWeight: 'bold',
    }
});

class SetupPlan extends React.Component {

    constructor() {
        super();
        this.state = {
            redirect: false,
            productName: "Loading",
            hasPlan: false,
            hasPaymentMethod: false,
            isTrial: true,
            startTimestamp: new Date().getTime() / 1000,
            trialEndTimestamp: new Date().getTime() / 1000 + 14 * 24 * 3600 * 1000,
            trialRemains: 14,
            planType: 21,
            productId: 5,
            unitCount: 10,
            // for 
            setPlan: true,
            isOldPlan: false,
            currentUnitCount: 10,
            currentPrice: 30,
            totalPrice: 'loading',
            discountPrice: 30,
            discounted: false,
            nextPaymentDate: '',
            isMonthly: true,
            selectedPlan: "Small_Monthly"
        };
        this.getAccount = this.getAccount.bind(this);
    }

    componentDidMount() {
        this.getAccount();
    }

    setCompletePlan() {
        this.setState({
            completePlan: true
        })
    }

    getAccount() {
        fetch('/api/account')
            .then(res => res.json())
            .then(data => {
                // TODO set flags
                console.log(data);
                if (data.planType) {
                    this.setState({ planType: data.planType });
                    this.setState({ productId: data.productId });
                    this.setState({ productName: data.productName });
                    this.setState({ currentUnitCount: data.unitCount });
                    this.setState({ currentPrice: this.getTotalPrice(data.unitCount, false) })
                    this.setState({ nextPaymentDate: moment(data.nextPaymentTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ trialEndDate: moment(data.trialEndTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ hasPlan: true });
                    this.setState({ hasPaymentMethod: data.hasPaymentMethod });
                    this.setState({ isOldPlan: data.isOldPlan });
                    this.setState({ isTrial: data.isTrial });
                    if (this.state.isOldPlan) {
                        this.setState({ setPlan: false });
                        if (this.state.planType === 1) {
                            console.log('set price for personal plan')
                            this.setState({ totalPrice: 35 });
                            this.setState({ currentPrice: 35 });
                        }
                        else {
                            console.log('set price for free plan')
                            this.setState({ totalPrice: 0 });
                            this.setState({ currentPrice: 0 });
                        }
                        return;
                    }
                    else {
                        this.setState({ setPlan: true });
                        this.setUnitCount(data.unitCount);
                    }
                }
                else {
                    this.setState({ hasPlan: false });
                    this.setState({ setPlan: true });
                    this.setState({ isTrial: true });
                    this.setUnitCount(this.state.unitCount);
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ hasPlan: false });
                this.setState({ setPlan: true });
                this.setState({ isTrial: true });
                this.setUnitCount(this.state.unitCount);
            })
    }

    handlePlanTypeChange = (isMonthly) => {
        this.setState({ isMonthly });
    }

    handleSubmit = event => {
        event.preventDefault();
        if (this.state.productId === 1 || this.state.productId === 2) {
            // old type
        }
        GA.Event('Dashboard', 'Change user count', 'setPlan');
        if (this.state.productName === "Small_Monthly" || this.state.productName === "Business_Monthly" || this.state.productName === "Small_Yearly" || this.state.productName === "Business_Yearly" || this.state.productName === "Enterprise_Yearly") {
            fetch("/api/plan/setPlan", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'planType': this.state.planType,
                    'productId': this.state.productId,
                    'unitCount': this.state.unitCount,
                })
            })
                .then((res) => {
                    console.log(res);
                    console.log(this);
                    if (res.status === 200) {
                        // do redirect
                        this.setState({ 'redirect': true });
                    }
                    else {
                        alert('something went wrong, please contact through chat');
                    }
                })
                .catch((e) => {
                    console.log(e);
                    alert(e);
                })
        } else {
            this.setState({ 'redirect': true });
        }
    };

    getTotalPrice = (unitCount, withDiscount = true) => {
        if (withDiscount && unitCount >= 100) {
            return unitCount * 240 / 100;
        }
        return unitCount * 3;
    }

    setUnitCount = (newUnitCount) => {
        this.setState({ unitCount: newUnitCount });
        const price = this.getTotalPrice(newUnitCount, false);
        this.setState({ totalPrice: price });
        if (newUnitCount === 15) {
            const discountPrice = this.getTotalPrice(newUnitCount, true);
            this.setState({ discountPrice: discountPrice, discounted: true });
        }
        else if (newUnitCount === 33) {
            this.setState({ discountPrice: price, discounted: false });
        }
        else {
            this.setState({ discountPrice: price, discounted: false });
        }
    }

    handleInputChange = (price, title, productName) => {
        let unitCount;
        let productId;

        if (productName === "Small_Monthly") {
            unitCount = 15;
            productId = 5;
        }
        else if (productName === "Business_Monthly") {
            unitCount = 33;
            productId = 6;
        }
        else if (productName === "Enterprise_Monthly") {
            unitCount = 1;
            productId = 7;
        } else if (productName === "Small_Yearly") {
            unitCount = 15;
            productId = 8;
        } else if (productName === "Business_Yearly") {
            unitCount = 33;
            productId = 9;
        } else if (productName === "Enterprise_Yearly") {
            unitCount = 1;
            productId = 10;
        }

        this.setState({
            selectedPlan: title,
            productName: productName,
            planType: 21,

        }, () => {
            if (unitCount) {
                this.setUnitCount(unitCount);
            }
        });
    }


    handleBlur = () => {
        if (this.unitCount < 0) {
            this.setUnitCount(0);
        }
    }

    trialAlert = () => {
        const { hasPlan, isTrial, trialEndDate } = this.state;
        return (
            ((hasPlan && isTrial && trialEndDate) ? (
                <Typography className="urgent-notice alert" color="primary" align="right">
                    You're free trial period ends on {trialEndDate}
                </Typography>
            ) : (
                <div></div>
            )
            )
        );

    }

    planSelectForm = () => {
        return <Box sx={{ maxWidth: 900, margin: 'auto', p: 2 }}>
            <Typography variant="h6" style={{ color: "#FF2B01" }} align="center" fontWeight="bold" mb={2}>
                <Button
                    onClick={() => this.handlePlanTypeChange(true)}
                    style={{
                        color: this.state.isMonthly ? "#FF2B01" : "#000000",
                    }}
                >
                    Monthly
                </Button>
                {" / "}
                <Button
                    onClick={() => this.handlePlanTypeChange(false)}
                    style={{
                        color: !this.state.isMonthly ? "#FF2B01" : "#000000",
                    }}
                >
                    Yearly
                </Button>
                <span style={{ backgroundColor: '#FF2B01', color: 'white', padding: '2px 5px', marginLeft: '5px' }}>
                    -12% off
                </span>
            </Typography>
            {this.renderPlans()}
        </Box>
    }

    showSteppers = () => {
        const activeStep = 3;
        return <SignUpSteps activeStep={activeStep} />
    }

    prependItems = () => {
        // TODO show trial end date
        return <div>
            {this.trialAlert()}
            {this.showSteppers()}
            <Typography variant="h5" component="h1" align="center" style={{ marginTop: '30px' }} >
                Choose your plan
            </Typography>
        </div>
    }
    appendItems = () => {
        const { isTrial } = this.state;
        return <Grid container spacing={4} justify="space-evenly" alignItems="center" justifyContent="center" >
            <Grid item md={8} sm={10}>
                {isTrial ?
                    <Typography variant="h7" component="p">
                        <ThumbUpAltOutlinedIcon style={{ marginRight: '8px' }}></ThumbUpAltOutlinedIcon>
                        Try free for 14 days
                    </Typography>
                    : <div></div>
                }
                <Typography variant="h7" component="p">
                    <CreditCardIcon style={{ marginRight: '8px' }}></CreditCardIcon>
                    100% Refund Policy.  If you are not satisfied, we are happy to money back.
                </Typography>
            </Grid>
        </Grid>
    }

    renderButton = (plan) => {
        const mixpanelMessage = 'kiara_app_com_setup_plan_button';
        if (plan.title === "Enterprise") {
            return (
                <RouterLink to="/setup-enterprise-plan" style={{ textDecoration: 'none', width: '100%' }}>
                    <MixpanelButton
                        mixpanelMessage={mixpanelMessage}
                        variant={this.state.selectedPlan === plan.title ? "contained" : "outlined"}
                        style={{
                            backgroundColor: this.state.selectedPlan === plan.title ? "#FF2B01" : "transparent",
                            color: this.state.selectedPlan === plan.title ? "#FFFFFF" : "#FF2B01",
                            borderColor: "#FF2B01",
                            width: '100%'
                        }}
                    >
                        Choose
                    </MixpanelButton>
                </RouterLink>
            );
        } else {
            return (
                <MixpanelButton
                    mixpanelMessage={mixpanelMessage}
                    variant={this.state.selectedPlan === plan.title ? "contained" : "outlined"}
                    style={{
                        backgroundColor: this.state.selectedPlan === plan.title ? "#FF2B01" : "transparent",
                        color: this.state.selectedPlan === plan.title ? "#FFFFFF" : "#FF2B01",
                        borderColor: "#FF2B01",
                    }}
                    fullWidth
                    onClick={() => this.handleInputChange(plan.price, plan.title, plan.productName)}
                >
                    Choose
                </MixpanelButton>
            );
        }
    }

    renderPlans = () => {
        const { isMonthly } = this.state;
        const planData = isMonthly ? [
            { title: "Small", price: "$45", description: "Up to 60 Members Unlimited Use", isSelected: true, productName: "Small_Monthly" },
            { title: "Business", price: "$99", description: "Up to 330 Members Unlimited Use", isSelected: false, productName: "Business_Monthly" },
            { title: "Enterprise", price: "Customize", description: "For larger organizations with custom requirements", isSelected: false, productName: "Enterprise_Monthly" }
        ] : [
            { title: "Small", price: "$475", description: "Up to 60 Members Unlimited Use", isSelected: true, productName: "Small_Yearly" },
            { title: "Business", price: "$1045", description: "Up to 330 Members Unlimited Use", isSelected: false, productName: "Business_Yearly" },
            { title: "Enterprise", price: "Customize", description: "For larger organizations with custom requirements", isSelected: false, productName: "Enterprise_Yearly" }
        ];

        return (
            <Box>
                <Grid container spacing={3} sx={{ mb: 6 }}>
                    {planData.map((plan, index) => (
                        <Grid item xs={12} sm={4} key={index}>
                            <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <Typography variant="h5" component="h2" fontWeight="bold" gutterBottom>
                                    {plan.title}
                                </Typography>
                                <Typography variant="h4" component="p" style={{ color: "#FF2B01" }} fontWeight="bold" gutterBottom>
                                    {plan.price}
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 2, flexGrow: 1 }}>
                                    {plan.description}
                                </Typography>
                                {this.renderButton(plan)}
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Button
                        variant="contained"
                        size="small"
                        style={{
                            backgroundColor: "#FF2B01",
                            color: "#FFFFFF",
                            borderColor: "#FF2B01",
                            width: 'auto',
                            minWidth: '200px',
                            maxWidth: '300px'
                        }}
                        onClick={this.handleSubmit}
                    >
                        Next
                    </Button>
                </Box>
            </Box>
        );
    }

    // no plan -> urges to select plan
    // no payment -> 
    // under trial -> shows period
    // under free plan -> 
    render() {
        const { redirect, productName } = this.state;
        if (redirect) {
            if (productName === "Small_Yearly" || productName === "Business_Yearly" || productName === "Enterprise_Yearly") {
                return <Redirect to="/setup-finish" ></Redirect>
            } else if (productName === "Enterprise_Monthly") {
                return <Redirect to="/setup-enterprise-plan" ></Redirect>
            } else {
                return <Redirect to="/setup-payment" > </Redirect>
            }
        }
        return (
            <SignUpTemplate maxWidth="md" prependItems={this.prependItems()} appendItems={this.appendItems()}>
                <div>
                    <CardContent>
                        {this.planSelectForm()}
                    </CardContent>
                    <MixpanelOnload message="kiara-app.com/setup-plan" />
                </div>
            </SignUpTemplate>
        )
    }
}
export default withStyles(useStyles)(SetupPlan);
